import React from 'react';

const StructuredData: React.FC = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "SportsOrganization",
    "name": "SDRA24 - Shaun De Souza Rugby Academy",
    "alternateName": "SDRA24",
    "url": "https://sdra24.co.zw",
    "logo": "https://sdra24.co.zw/images/logo.png",
    "description": "High-performance rugby development academy committed to Grassroots to Greatness. Developing elite athletes and quality coaches through structured, values-driven pathways.",
    "slogan": "Grassroots to Greatness",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Harare",
      "addressCountry": "ZW",
      "streetAddress": "Old Hararians Sports Club"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+263-77-231-1299",
      "contactType": "Customer Service",
      "email": "admin@sdra.co.zw"
    },
    "founder": {
      "@type": "Person",
      "name": "Shaun De Souza",
      "jobTitle": "Founder & Head of Coaching"
    },
    "sport": "Rugby",
    "areaServed": {
      "@type": "Country",
      "name": "Zimbabwe"
    }
  };

  const sportsActivitySchema = {
    "@context": "https://schema.org",
    "@type": "SportsActivityLocation",
    "name": "SDRA24 Training Sessions",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Harare",
      "addressCountry": "ZW",
      "streetAddress": "Old Hararians Sports Club"
    },
    "openingHours": "Su 10:00-12:00"
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(sportsActivitySchema) }}
      />
    </>
  );
};

export default StructuredData;

